import en from './en.json';
import ru from './ru.json';
import fr from './fr.json';
import de from './de.json';
import hy from './hy.json';

const modules = { en, fr, ru, de, hy };

module.exports = modules;
